export const TENANT = {
    FOCUS: "focus",
    BLACKROCK: "blackrock",
    JPMORGAN: "jpmorgan",
    WISDOMTREE: "wisdomtree",
    RIVERFRONT: "riverfront",
    FIDELITY: "fidelity",
    RAYMONDJAMES: "raymondjames"
};

export const MAILTO = {
   link: "mailto:Advisor@service.55-ip.com",
   text: "Advisor@service.55-ip.com"
};

export const MAILTOFOGOTPASSWORD = {
    link: "mailto:password@service.55-ip.com?subject=Password reset request",
    text: "password@service.55-ip.com"
 };

 export const MAILTORESETPASSWORD = {
    link: "mailto:password@service.55-ip.com?subject=Password change request",
    text: "password@service.55-ip.com"
 };

export const ERRORCODE = {
    ONE: 1,
    FIVE: 5,
    SEVEN: 7,
    NINE: 9,
    ELEVEN: 11,
};

export const EMAIL_OTP_TEMPLATE = "awm-109771-email-otp-template";
export const DEPLOYMENT_ID = "110133";
export const DEFAULT_LOCALE = "en";
export const VERIFICATION_SUBJECT = "Verification Code for 55ip";
